requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    const instances = (window.productBackInStock = window.productBackInStock || {});

    function readVariantData(sectionId) {
      const dataEl = document.getElementById(`ProductBackInStockData-${sectionId}`);
      if (!dataEl) return {};

      try {
        const parsed = JSON.parse(dataEl.textContent);
        return (parsed && parsed.variants) || {};
      } catch (error) {
        return {};
      }
    }

    function createInstance(container) {
      const sectionId = container.dataset.backInStockSection;
      if (!sectionId) return null;

      const variants = readVariantData(sectionId);
      const hasVariantData = Object.keys(variants).length > 0;
      const tagsInput = container.querySelector('[data-back-in-stock-tags]');
      const returnToInput = container.querySelector('[data-back-in-stock-return-to]');
      const customerForm = container.querySelector('form');
      const agreementInput = container.querySelector('[data-back-in-stock-agreement]');
      const agreementError = container.querySelector('[data-back-in-stock-agreement-error]');
      const sectionEl = document.getElementById(`MainProduct-${sectionId}`);
      const root = sectionEl || document;
      const productEl = root.querySelector('.product');
      const productForm = document.getElementById(`product-form-${sectionId}`);

      /* A confirmed subscription keeps the form on screen so the success
         message survives the first variant sync. */
      let keepVisible =
        container.dataset.backInStockPosted === 'true' ||
        window.location.search.indexOf('contact_posted=true') !== -1;
      let observer;
      let unsubscribe;

      function getVariantId() {
        const variantInput = productForm && productForm.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) return String(variantInput.value);

        if (productEl && productEl.dataset.selectedVariantId) return String(productEl.dataset.selectedVariantId);

        return '';
      }

      function applyVariant(variantId) {
        const variant = variants[variantId];
        if (!variant) return false;

        container.hidden = keepVisible ? false : !variant.soldOut;

        if (tagsInput) tagsInput.value = `newsletter, ${variant.tag}`;
        if (returnToInput) {
          returnToInput.value = `${window.location.pathname}?variant=${variantId}&contact_posted=true`;
        }

        return true;
      }

      function sync(variantId) {
        /* Without variant data there is nothing to compare against, so the
           server-rendered state is left untouched. */
        if (!hasVariantData) return;

        if (!applyVariant(variantId || getVariantId())) container.hidden = !keepVisible;
        keepVisible = false;
      }

      function onVariantInputChange() {
        sync();
      }

      function onCustomerFormSubmit(event) {
        if (agreementInput && !agreementInput.checked) {
          event.preventDefault();
          if (agreementError) agreementError.hidden = false;
          return;
        }

        if (agreementError) agreementError.hidden = true;

        keepVisible = true;
        sync();
      }

      if (productForm) {
        const variantInput = productForm.querySelector('input[name="id"]');
        if (variantInput) variantInput.addEventListener('change', onVariantInputChange);
      }

      if (productEl && window.MutationObserver) {
        observer = new MutationObserver(() => sync());
        observer.observe(productEl, { attributes: true, attributeFilter: ['data-selected-variant-id'] });
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const eventSectionId = event && event.data && event.data.sectionId;
          if (eventSectionId && String(eventSectionId) !== sectionId) return;

          const eventVariant = event && event.data && event.data.variant;
          sync(eventVariant ? String(eventVariant.id) : '');
        });
      }

      if (customerForm) customerForm.addEventListener('submit', onCustomerFormSubmit);

      function destroy() {
        if (observer) observer.disconnect();
        if (unsubscribe) unsubscribe();
        if (productForm) {
          const variantInput = productForm.querySelector('input[name="id"]');
          if (variantInput) variantInput.removeEventListener('change', onVariantInputChange);
        }
        if (customerForm) customerForm.removeEventListener('submit', onCustomerFormSubmit);
      }

      const unloadHandler = (event) => {
        if (event.target && sectionEl && event.target !== sectionEl) return;
        destroy();
      };
      document.addEventListener('shopify:section:unload', unloadHandler);

      sync();

      return {
        destroy() {
          destroy();
          document.removeEventListener('shopify:section:unload', unloadHandler);
        },
      };
    }

    document.querySelectorAll('[data-back-in-stock-section]').forEach((container) => {
      const sectionId = container.dataset.backInStockSection;
      const previous = instances[sectionId];
      if (previous) previous.destroy();
      instances[sectionId] = createInstance(container);
    });

    if (window.location.search.indexOf('contact_posted=true') !== -1 && history.replaceState) {
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('contact_posted');
      history.replaceState({}, '', cleanUrl.toString());
    }

    if (typeof scriptController !== 'undefined') scriptController.scripts.push('product-back-in-stock.js');
  });
});